
const updateContext = ( scopeEl = document ) => {

	// Get SKU and Lang.
	const sku = scopeEl.querySelector( 'input[name="aid"]' )?.value;
	const lng = ( document.documentElement.lang || 'de-AT' ).replace( '-', '_' );

	if ( ! sku ) {
		return false;
	}

	const newContext = {
		type: "PRODUCT",
		data: [ sku ]
	};

	if ( lng && lng !== 'de_AT' ) {
		newContext['lng'] = lng;
	}

	// Get DY Object and update context.
	const DY = window.DY = window.DY || {};
	DY.recommendationContext = newContext;
	return newContext;
}

document.addEventListener( 'finished_change_variant', ( ev ) => {
	const popupEl = ev.target.closest( '.mdl_popup' );
	if ( popupEl ) {
		// In case the popup was opened, then closed before it could load the context.
		if ( popupEl.open ) {
			updateContext( ev.target );
		}
	} else {
		updateContext( ev.target );
	}
} );

// Get DY Object.
let prevContext = null;
document.addEventListener( 'popup_opened.sl', ( ev ) => {
	if ( ! ev.target.matches( '#popup_article' ) ) {
		return;
	}

	const DY = window.DY = window.DY || {};
	if ( DY.recommendationContext ) {
		prevContext = DY.recommendationContext;
	}
} )

document.addEventListener( 'popup_closed.sl', ( ev ) => {
	if ( ! ev.target.matches( '#popup_article' ) ) {
		return;
	}

	const DY = window.DY = window.DY || {};
	if ( prevContext ) {
		DY.recommendationContext = prevContext;
	}
} );
